export default class MainNavigation {
  constructor(_root) {
    this._root = _root;
    this._links = Array.from(
      this._root.querySelectorAll('.main-navigation__link'),
    );
  }

  setActiveState() {
    this._links.forEach((item) => {
      const href = item.href;
      if (href === window.location.href) {
        item.classList.add('main-navigation__link--active');
      }
    });
  }
}
